export function handleFileUrl (url) {
    var Expression = /http(s)?:\/\/*?/
    var objExp = new RegExp(Expression)
    if (objExp.test(url)) {
      return url
    } else {
      return process.env.VUE_APP_FILE_SERVE + url
    }
  }
  